export enum NivelAlgoritmoEnum {
  FACIL = 0,
  MEDIO = 1,
  DIFICIL = 2,
}

export enum TextoNivelAlgoritmoEnum {
  FACIL = "Fácil",
  MEDIO = "Médio",
  DIFICIL = "Difícil",
}
